module.exports = __webpack_public_path__ + "files/d7b3ef83d932073143d1c7a694148955.png";